<div class="flex justify-center flex-wrap">
  <div class="flex items-center justify-center">Please Confirm</div>
</div>
<div class="flex justify-center flex-wrap">
  <div class="flex items-center justify-center">Are you sure you want to create:</div>
</div>
<br />
<div class="flex justify-center flex-wrap">
  <div class="flex items-center justify-center">
    <h4>{{ dialogConfig.data }}</h4>
  </div>
</div>
<br />
<div class="flex justify-between flex-wrap">
  <div class="flex items-center justify-center">
    <p-button variant="outlined" (click)="close($event)">Cancel</p-button>
  </div>
  <div class="flex items-center justify-center">
    <p-button [raised]="true" (click)="confirm()">Confirm</p-button>
  </div>
</div>
